import { Option } from '@components/FormInputs/Select';

export const dayOptions = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: i + 1 }));
export const fullMonths = new Set([1, 3, 5, 7, 8, 10, 12]);
export const monthOptions = Array.from({ length: 12 }, (_, i) => {
  const date = new Date();
  date.setDate(1);
  date.setMonth(i);
  const label = date.toLocaleDateString('default', { month: 'short' });
  return { value: i + 1, label };
});
const year = new Date().getFullYear();
export const yearOptions = Array.from({ length: year - 1900 }, (_, i) => ({
  value: year - i,
  label: year - i,
}));

export const getOption = (
  options: Option<number>[],
  value?: number,
): Option<number> | undefined => {
  if (!value) {
    return undefined;
  }
  return options.find((option) => option.value === value);
};
